module.exports = __webpack_public_path__ + "img/zcfg.a3dcd24f.jpg";